module.exports = __webpack_public_path__ + "img/fashion_43.5d3d1e62.jpg";